// src/Modal.js
import React from 'react';
import '../css/whatsnew.css';

const closeButtonStyle = {
  float: 'right'
}

function WhatsNew({ closeModal }) {
  return (
    <div className="modal-overlay">
      <div className="popup">
        <h1>Les nouveautés - version 1.1.0</h1>
        <h2>Majeurs</h2>
        <ul>
          <li>Garder l'utilisateur connecté durant 1h</li>
          <li>Ajout de la possibilité de se déconnecter</li>
          <li>Afin d'éviter que des cadeaux soient achetés en dehors des dates, la liste n'est accessible que du 1 décembre au 1 mars</li>
          <li>Ajout de la possibilité de vous communiquer un message pendant la période d'ouverture</li>
        </ul>
        <h2>Mineurs</h2>
        <ul>
          <li>Mail de contact pré-formaté</li>
          <li>Appuyer sur Enter permet de se connecter</li>
          <li>Ajout de la possibilité de voir les nouveautés</li>
          <li>Ajout d'un message d'erreur si le nom d'utilisateur ou mot de passe est incorrect</li>
          <li>Correction de bugs</li>
        </ul>
        <button style={closeButtonStyle} onClick={closeModal}>Fermer</button>
      </div>
    </div>
  );
}

export default WhatsNew;
